import * as React from "react";

/** Aligné sur Tailwind `lg` — en dessous : navigation drawer */
export const COMPACT_LAYOUT_MAX_WIDTH = 1023;

export function useCompactLayout() {
  const [isCompact, setIsCompact] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${COMPACT_LAYOUT_MAX_WIDTH}px)`);

    const onChange = () => {
      setIsCompact(window.innerWidth <= COMPACT_LAYOUT_MAX_WIDTH);
    };

    mql.addEventListener("change", onChange);
    onChange();

    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isCompact;
}
